import { render, staticRenderFns } from "./PreStudentApplicationForm.vue?vue&type=template&id=70349aa1"
import script from "./PreStudentApplicationForm.vue?vue&type=script&lang=js"
export * from "./PreStudentApplicationForm.vue?vue&type=script&lang=js"
import style0 from "./PreStudentApplicationForm.vue?vue&type=style&index=0&id=70349aa1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports